import React, { FC, useState } from 'react';
import { ExclamationCircleIcon, ExclamationIcon } from '@heroicons/react/outline';
import create from 'zustand';

// components
import Modal from 'components/Modal';
import Button from 'components/Button';
import Stack from 'components/Stack';
import clsx from 'clsx';

const variants: any = {
  error: 'text-hazel-red-100',
  success: 'text-green-500',
  warning: 'text-yellow-500'
};

const ConfirmDialog: FC = () => {
  const { title, message, onSubmit, close, open, variant = 'error' } = useConfirmDialogStore();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      await onSubmit(true);
      setIsLoading(false);
      close();
    } catch (err) {
      console.log(err)
      setIsLoading(false);
      close();
    }
  };

  return (
    <Modal
      open={open}
      onClose={close}
      //   title={title}
      classNameTitle="bg-hazel-white-200 text-black"
      isConfirmOpen
      size="xl"
    >
      <div className="py-2">
        <div className="font-Sohne-Regular text-lg mb-4">{title}</div>
        <div className="bg-[#f0f0ee] h-[200px] p-5 rounded-lg flex items-center flex-col justify-center">
          <div className="flex justify-center">
            {variant === 'warning' ? (
              <ExclamationIcon className={clsx('h-12 w-12', variants[variant])} />
            ) : (
              <ExclamationCircleIcon className={clsx('h-12 w-12 text-red', variants[variant])} />
            )}
          </div>
          <div className="text-center mt-2">{message}</div>
        </div>

        <Stack spacingX={3} className="justify-end mt-5">
          <Button
            variant="invisible"
            rounded="full"
            classNameButton="!px-6 !py-1 text-xs bg-hazel-light-gray-200/40 text-white hover:text-hazel-light-gray-200"
            disabled={isLoading}
            onClick={close}
          >
            Cancel
          </Button>
          <Button
            variant="hazel-btn-yellow-100"
            rounded="full"
            classNameButton="!px-6 !py-1 text-xs"
            isLoading={isLoading}
            disabled={isLoading}
            onClick={() => handleDelete()}
          >
            Confirm
          </Button>
        </Stack>
      </div>
    </Modal>
  );
};

interface IConfirm {
  title: string;
  message: string;
  variant?: 'error' | 'success' | 'warning';
  onSubmit: (x: boolean) => Promise<any> | void;
}

const useConfirmDialogStore = create<IConfirm & { close: () => void; open: boolean }>((set) => ({
  title: '',
  message: '',
  open: false,
  variant: 'error',
  onSubmit: (open: boolean) => set({ open }),
  close: () => set({ open: false })
}));

export const confirmDialog = ({ title, message, variant = 'error', onSubmit }: IConfirm) => {
  useConfirmDialogStore.setState({
    title,
    open: true,
    variant,
    message,
    onSubmit
  });
};

export default ConfirmDialog;
